import { clearBetterStackUser, setBetterStackUser } from '../betterstack';

export class AnalyticsService {

  public static readonly instance = new AnalyticsService();

  setUser (
    id: string,
    name: string,
    email: string,) {
    setBetterStackUser({
      id,
      username: name,
      email,
    });
  }

  clearUser() {
    clearBetterStackUser();
  }

}
